
import { _bucket_, apiUrl, wsUrl, identityId,cognitoUserPoolId, userPoolWebClientId, concatBucket, s3BaseUrl } from "../helper/path";
import logo from '../assets/images/logo.svg'

const configs = {
    "shadhin": {
        site_logo: {
            "logo": "meet_mates_logo",
            "width": "150px",
            "icon": "meetmates_icon"
        },
        fav_icon: `${window.location.origin}/meetmates.png`,
        photo_avatar: "photo_avatar",
        user_avatar: "line-md:account-small", // iconify icon name
        base_urls: {
            api: apiUrl(),
            ws: wsUrl(),
        },
        constants: {
            identityPoolId: identityId(),
            userPoolId: cognitoUserPoolId(),
            userPoolWebClientId: userPoolWebClientId(),
            bucket: _bucket_(),
            recording_concat_bucket: concatBucket(),
            s3FileBaseUrl: s3BaseUrl()
        }
    },
}


export default {
    ...configs[process.env.REACT_APP_COMPANY_NAME],
    site_company: process.env.REACT_APP_COMPANY_NAME,
    site_name: process.env.REACT_APP_COMPANY_NAME,
    fb_link: 'https://www.facebook.com/postjini1/',
    twitter_link: 'https://x.com/PostJiniLLC',
    linkedin_link: 'https://www.linkedin.com/company/postjini/',
    mobile_number: '+880 16 3333 66 22',
    email_address: ' hello@shadhinlab.com',
    logo
};